import "core-js/modules/es6.array.map.js";

// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
var some = require('lodash/some'); // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration


var isArray = require('lodash/isArray'); // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration


var isPlainObject = require('lodash/isPlainObject'); // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration


var isObject = require('lodash/isObject'); // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration


var keys = require('lodash/keys');

function isKeywordMatch(keywords, key) {
  return some(keywords, function (keyword) {
    return key.toLowerCase().indexOf(keyword.toLowerCase()) !== -1;
  });
}
/**
 * Parses an object and redacts any keys listed in keywords
 *
 * Originally from https://github.com/shaunburdick/redact-object
 *
 * @param  {object}   target     The target object to scan for redactable items
 * @param  {string[]} keywords   A list of members to redact
 * @param  {string}   replaceVal Optional custom replace value
 * @return {object}              the new redacted object
 */


export function doRedact(target, keywords, replaceVal) {
  if (!isObject(target)) {
    // If it's not an object then it's a primitive. Nothing to redact.
    return target;
  }

  if (isArray(target)) {
    // Create a new array with each value having been redacted
    // Redact each value of the array.
    return target.map(function (val) {
      return doRedact(val, keywords, replaceVal);
    });
  }

  if (isPlainObject(target)) {
    return keys(target).reduce(function (newObj, key) {
      var isMatch = isKeywordMatch(keywords, key);
      /* eslint-disable no-param-reassign */

      if (isMatch) {
        newObj[key] = replaceVal;
      } else {
        newObj[key] = doRedact(target[key], keywords, replaceVal);
      }
      /* eslint-enable no-param-reassign */


      return newObj;
    }, {});
  } // Redaction only works on arrays, plain objects, and primitives.


  throw new Error('Unsupported value for redaction');
} // Stay up-to-date with https://github.com/NerdWallet/nw_api/blob/master/nw_api/config.py#L12

export var sensitiveParams = ['password', 'passwd', 'secret', 'authorization', 'api_key', 'apikey', 'sentry_dsn', 'token', 'cobrand_token', 'user_token', 'uid', 'phpsessid', 'ssn', 'last4SSN', 'last_four', 'last_four_ssn', 'firstName', 'first_name', 'middle_initial', 'lastName', 'last_name', 'full_name', 'date_of_birth', 'homeAddressLine1', 'address_line_one', 'homeAddressLine2', 'address_line_two', 'street_address', 'street', 'street2', 'city', 'state', 'zip', 'zipcode', 'postal_code', 'email', 'phone_number', 'offer', 'account_number', 'routing_number', 'bill_pin'];
export var replaceText = '[REDACTED]';
export default function redact(obj) {
  var redactKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var text = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : replaceText;
  return doRedact(obj, [].concat(sensitiveParams, redactKeys), text);
}